import { render, staticRenderFns } from "./DescriptionTabComponent.vue?vue&type=template&id=3d056614&scoped=true"
import script from "./DescriptionTabComponent.js?vue&type=script&lang=js&external"
export * from "./DescriptionTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./DescriptionTabComponent.vue?vue&type=style&index=0&id=3d056614&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d056614",
  null
  
)

export default component.exports